<template>
  <div>
    <!-- Seleção do Diagnóstico -->
    <v-row class="mt-0" no-gutters>
      <v-spacer />
      <v-col cols="4">
        <v-select
          v-model="diagnostico"
          :items="diagnosticos"
          item-text="nome"
          item-value="id"
          label="Diagnóstico:"
          return-object
        />
      </v-col>
    </v-row>

    <!-- Gerenciamento de Dispensas do Diagnóstico -->
    <v-row>
      <!-- Informações -->
      <v-col cols="12">
        <v-card-widget title="Informações">
          <div slot="widget-content">
            <v-row no-gutters>
              <v-col cols="6">
                <span class="font-weight-bold">Usuário: </span>
                <span class="font-weight-light">{{ usuario.nome }}</span>
              </v-col>
              <v-col
                v-if="unidade.id"
                cols="6"
              >
                <span class="font-weight-bold">Unidade: </span>
                <span class="font-weight-light">{{
                  `${unidade.sigla} - ${unidade.nome}`
                }}</span>
              </v-col>
            </v-row>
          </div>
        </v-card-widget>
      </v-col>

      <!-- Formulário -->
      <v-col cols="12">
        <v-card-widget
          :enable-actions="false"
          title="Gerenciamento de Dispensas do Diagnóstico"
        >
          <!-- Diagnóstico selecionado -->
          <div v-if="diagnostico" slot="widget-content">
            <!-- Formulário de Cadastro das dispensas -->
            <!-- Disponível somente enquanto o diagnóstico não iniciar (FUTURO) -->
            <v-row v-if="diagnostico.status === 'FUTURO'" no-gutters>
              <v-col cols="12">
                <dispensa-form
                  :diagnostico="diagnostico"
                  :dispensas="dispensas"
                  :motivos="motivos"
                  :is-edicao="isEdicao"
                  :dispensa-update="dispensaUpdate"
                  @return="(value) => addDispensa(value)"
                  @motivo="(value) => addMotivo(value)"
                  @deleteMotivo="(value) => excluirMotivo(value)"
                  @reset="() => reset()"
                />
              </v-col>
            </v-row>

            <!-- Diagnóstico já iniciado ou finalizado (ATUAL ou FINALIZADO) -->
            <v-row v-else no-gutters>
              <v-col cols="12">
                <app-alert
                  :message="mensagemPrazo"
                  class="ma-4"
                />
              </v-col>
            </v-row>

            <!-- Listagem e gerenciamento das dispensas -->
            <!-- Edição e Exclusão somente enquanto o diagnóstico não iniciar (FUTURO)-->
            <v-row no-gutters>
              <v-col cols="12">
                <dispensa-list
                  :diagnostico="diagnostico"
                  :dispensas="dispensas"
                  :motivos="motivos"
                  @update="(value) => editar(value)"
                  @delete="(value) => excluir(value)"
                  @reset="() => reset()"
                />
              </v-col>
            </v-row>
          </div>

          <!-- Diagnóstico não selecionado -->
          <div v-else slot="widget-content">
            <v-row no-gutters>
              <v-col cols="12">
                <app-alert
                  icon="warning"
                  message="Selecione o diagnóstico para prosseguir"
                  type="warning"
                  class="ma-4"
                />
              </v-col>
            </v-row>
          </div>
        </v-card-widget>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import VCardWidget from '@/components/VWidget';
import DispensaForm from '@/components/gerenciamento/diagnostico/DispensaForm';
import DispensaList from '@/components/gerenciamento/diagnostico/DispensaList';
import AppAlert from '@/components/core/AppAlert';
import Data from '@/modules/data';

const dispensaDiagnosticoRepository = RepositoryFactory.get('dispensaDiagnostico');
const motivoDispensaDiagnosticoRepository = RepositoryFactory.get('motivoDispensaDiagnostico');

export default {
  name: 'DispensaDiagnostico',

  components: {
    VCardWidget,
    DispensaForm,
    DispensaList,
    AppAlert,
  },

  data() {
    return {
      dispensaUpdate: null,
      dispensas: [],
      motivos: [],
      isEdicao: false,
    };
  },

  computed: {
    ...mapState({
      usuario: (state) => state.auth.usuario,
      unidade: (state) => state.auth.unidade,
      comissao: (state) => state.auth.comissao,
    }),
    diagnostico: {
      get() {
        return this.$store.state.diagnostico.diagnosticoComissao;
      },
      set(diagnostico) {
        this.$store.dispatch('diagnostico/setDiagnosticoComissao', diagnostico);
      },
    },
    diagnosticos: {
      get() {
        return this.$store.state.diagnostico.diagnosticosComissao;
      },
      set(diagnosticos) {
        this.$store.dispatch('diagnostico/setDiagnosticosComissao', diagnosticos);
      },
    },
    mensagemPrazo() {
      if (this.diagnostico) {
        if (this.diagnostico.status === 'ATUAL') {
          return `O diagnóstico selecionado já começou. Início em (${Data.format(this.diagnostico.inicio)}).`;
        }
        if (this.diagnostico.status === 'FINALIZADO') {
          return `O diagnóstico selecionado já terminou. Termino em (${Data.format(this.diagnostico.fim)}).`;
        }
      }
      return '';
    },
  },

  watch: {
    comissao(value) {
      if (!value) {
        this.$router.push('403');
      }
    },
    diagnostico(value) {
      this.load(value ? value.id : null);
    },
  },

  created() {
    this.load(this.diagnostico ? this.diagnostico.id : null);
  },

  updated() {
    if (!this.comissao) {
      this.$router.push('/403');
    }
  },

  methods: {
    load(diagnosticoId) {
      if (diagnosticoId) {
        dispensaDiagnosticoRepository.getAll(diagnosticoId).then((response) => {
          this.dispensas = response.data;
          motivoDispensaDiagnosticoRepository.getAll().then((response2) => {
            this.motivos = response2.data;
          });
        });
      }
    },
    addDispensa(dispensa) {
      if (this.isEdicao) {
        const index = this.dispensas.findIndex((d) => d.diagnostico.id === dispensa.diagnostico.id
          && d.usuario.id === dispensa.usuario.id);

        if (index !== -1) {
          this.dispensas.splice(index, 1, dispensa);
        }
        this.isEdicao = false;
      } else {
        this.dispensas.push(dispensa);
      }
    },
    addMotivo(motivo) {
      const index = this.motivos.findIndex((m) => m.id === motivo.id);

      if (index === -1) {
        this.motivos.push(motivo);
      } else {
        this.motivos.splice(index, 1, motivo);

        // Atualiza os motivos das dispensas sem a necessidade de fazer a carga dos dados novamente
        this.dispensas = this.dispensas.map((d) => ({ ...d, motivo: this.motivos.find((m) => m.id === d.motivo.id) }));
      }
    },
    editar(item) {
      // Sobre o scroll até a altura do formulário
      window.scrollTo({
        top: 40,
        left: 0,
        behavior: 'smooth',
      });

      this.dispensaUpdate = { ...item };
      this.isEdicao = true;
    },
    excluir(item) {
      const index = this.dispensas.findIndex((d) => d.diagnostico.id === item.diagnostico.id
        && d.usuario.id === item.usuario.id);

      if (index !== -1) {
        this.dispensas.splice(index, 1);
      }
    },
    excluirMotivo(motivo) {
      const index = this.motivos.findIndex((m) => m.id === motivo.id);

      if (index !== -1) {
        this.motivos.splice(index, 1);
      }
    },
    reset() {
      this.isEdicao = false;
    },
  },
};
</script>
